import React from 'react';
import ReactToPrint from "react-to-print";

export default class Page6 extends React.Component {

    render() {

        const {pageData} = this.props;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <div
                                                className="lightgreencontentbg keyquestionpad lightbgcontentShrink react-print-none">

                                                <div className="paratop uiheading"><p><span
                                                    className="subtiltereg">Immediate impact</span></p></div>
                                                <div className="paratop"><p>It is critical to manage the initial
                                                    three minutes, as during this time your impact is attended
                                                    to most by the other person and impressions are formed.
                                                    These impressions can be difficult to overcome, so it is
                                                    best to ensure our impact is as we intend it to be during
                                                    this time. Do this by building rapport, listening and
                                                    sharing information to help increase your
                                                    approachability.</p></div>
                                                <div className="paratop uiheading"><p><span
                                                    className="subtiltereg ">Attend to non-verbal behaviour</span>
                                                </p></div>
                                                <div className="paratop uiheading"><p>Be aware of your own and
                                                    the other person’s behaviours. This will give you the
                                                    awareness of how they are feeling so you can adapt
                                                    accordingly to increase your positive impact.</p></div>
                                            </div>
                                            <br/>

                                                <div className="circle_title">
		<span className="heading">
		<img className="heading_image" src={require('@images/browndot.jpg')}/>
		</span>
                                                    <span className="heading">IMPACT MANAGEMENT TOOL</span>
                                                </div>
                                                <p>This exercise will help you with the evaluation stage of the
                                                    model described earlier. Doing so
                                                    will enable you to identify themes relating to high or low
                                                    impact and therefore help you to modify
                                                    your approach.</p>
                                                <div className="border_subtitle">Step 1</div>
                                                <div className="uiheading" style={{paddingBottom:'0px'}}><p>Think
                                                    about two situations, one where you had a high impact and
                                                    one where your impact was low.</p></div>
                                                <ul className="greenbullet-list">
                                                    <li>For example, a high-impact situation might be when you
                                                        did a presentation that blew people away!
                                                    </li>
                                                    <li className="list-bottom-pad">A low-impact situation might
                                                        be when you put together a business case that people
                                                        were not persuaded by.
                                                    </li>

                                                </ul>
                                                <div className="border_subtitle">Step 2</div>
                                                <p>Answer the questions below with each of these situations in
                                                    mind.</p>
                                                <ReactToPrint
                                                    trigger={() => <div className={'d-flex justify-content-end'}>
                                                        <div onClick={this.downloadPdf} className="button-print">Print</div>
                                                    </div>}
                                                    content={ () => {
                                                        let html = document.body.getElementsByClassName('ilead-tools-pages-content')[0].cloneNode(true);

                                                        let div1 = document.createElement('div');
                                                        div1.className = 'ilead-tools-pages';
                                                        div1.appendChild(html);

                                                        let div2 = document.createElement('div');
                                                        div2.className = 'ilead-tools-body react-print';
                                                        div2.appendChild(div1);

                                                        return div2.cloneNode(true);
                                                    }}
                                                />
                                                <br/>
                                                    <table width="100%" border="0" cellSpacing="0"
                                                           cellPadding="0"
                                                           className="ilead_v_sport  tablesrink uiheading ilead_v_sport_new_task">
                                                        <tbody>
                                                        <tr>
                                                            <th width="40%" align="left" valign="center"
                                                                className="green_curve">Impact Management Tool
                                                            </th>
                                                            <th width="30%" align="left" valign="top">High
                                                                Impact
                                                            </th>
                                                            <th width="30%" align="left" valign="top"
                                                                className=" green_curve1">Low Impact
                                                            </th>
                                                        </tr>


                                                        <tr>
                                                            <td width="40%" align="left" valign="center"
                                                                className="lightgreen subtiltereg "
                                                                style={{paddingBottom:'0px'}}>The situation:
                                                            </td>
                                                            <td width="30%" align="left" valign="top"
                                                                className="lightgreen "></td>
                                                            <td width="30%" align="left" valign="top"
                                                                className="lightgreen "></td>
                                                        </tr>


                                                        <tr>
                                                            <td width="30%" align="left" valign="center"
                                                                className="darkgreen ">
                                                                <ul className="greenbullet-list">
                                                                    <li><p>Who was involved (e.g. the
                                                                        audience)?</p></li>
                                                                </ul>
                                                            </td>
                                                            <td width="30%" align="left" valign="top"
                                                                className="darkgreen ">
                                                                <textarea className="textboximpact1"
                                                                          name="HighImpactWhoWasInvolved"
                                                                          id="HighImpactWhoWasInvolved"
                                                                          value={pageData?.TheSituation?.HighImpactWhoWasInvolved}
                                                                          onChange={this.props.handleChangePageData('TheSituation')}/>
                                                            </td>
                                                            <td width="30%" align="left" valign="top"
                                                                className="darkgreen ">
                                                                <textarea className="textboximpact1"
                                                                          name="LowImpactWhoWasInvolved"
                                                                          id="LowImpactWhoWasInvolved"
                                                                          value={pageData?.TheSituation?.LowImpactWhoWasInvolved}
                                                                          onChange={this.props.handleChangePageData('TheSituation')}/>
                                                            </td>


                                                        </tr>
                                                        <tr>
                                                            <td width="30%" align="left" valign="center"
                                                                className="darkgreen ">
                                                                <ul className="greenbullet-list">
                                                                    <li><p>What did I hope to achieve?</p></li>
                                                                </ul>
                                                            </td>
                                                            <td width="30%" align="left" valign="top"
                                                                className="darkgreen ">
                                                                <textarea className="textboximpact1"
                                                                          name="HighImpactWhatDidIHopeToAchieve"
                                                                          id="HighImpactWhatDidIHopeToAchieve"
                                                                          value={pageData?.TheSituation?.HighImpactWhatDidIHopeToAchieve}
                                                                          onChange={this.props.handleChangePageData('TheSituation')}/>
                                                            </td>
                                                            <td width="30%" align="left" valign="top"
                                                                className="darkgreen ">
                                                                <textarea className="textboximpact1"
                                                                          name="LowImpactWhatDidIHopeToAchieve"
                                                                          id="LowImpactWhatDidIHopeToAchieve"
                                                                          value={pageData?.TheSituation?.LowImpactWhatDidIHopeToAchieve}
                                                                          onChange={this.props.handleChangePageData('TheSituation')}/>
                                                            </td>


                                                        </tr>
                                                        <tr>
                                                            <td width="30%" align="left" valign="center"
                                                                className="darkgreen ">
                                                                <ul className="greenbullet-list">
                                                                    <li><p>What approach did I take?</p></li>
                                                                </ul>
                                                            </td>
                                                            <td width="30%" align="left" valign="top"
                                                                className="darkgreen ">
                                                                <textarea className="textboximpact1"
                                                                          name="HighImpactWhatApproachDidITake"
                                                                          id="HighImpactWhatApproachDidITake"
                                                                          value={pageData?.TheSituation?.HighImpactWhatApproachDidITake}
                                                                          onChange={this.props.handleChangePageData('TheSituation')}/>
                                                            </td>
                                                            <td width="30%" align="left" valign="top"
                                                                className="darkgreen ">
                                                                <textarea className="textboximpact1"
                                                                          name="LowImpactWhatApproachDidITake"
                                                                          id="LowImpactWhatApproachDidITake"
                                                                          value={pageData?.TheSituation?.LowImpactWhatApproachDidITake}
                                                                          onChange={this.props.handleChangePageData('TheSituation')}/>
                                                            </td>


                                                        </tr>
                                                        <tr>
                                                            <td width="30%" align="left" valign="center"
                                                                className="darkgreen ">
                                                                <ul className="greenbullet-list">
                                                                    <li><p>Why did I take this approach?</p>
                                                                    </li>
                                                                </ul>
                                                            </td>
                                                            <td width="30%" align="left" valign="top"
                                                                className="darkgreen ">
                                                                <textarea className="textboximpact1"
                                                                          name="HighImpactWhyDidITakeThisApproach"
                                                                          id="HighImpactWhyDidITakeThisApproach"
                                                                          value={pageData?.TheSituation?.HighImpactWhyDidITakeThisApproach}
                                                                          onChange={this.props.handleChangePageData('TheSituation')}/>
                                                            </td>
                                                            <td width="30%" align="left" valign="top"
                                                                className="darkgreen ">
                                                                <textarea className="textboximpact1"
                                                                          name="LowImpactWhyDidITakeThisApproach"
                                                                          id="LowImpactWhyDidITakeThisApproach"
                                                                          value={pageData?.TheSituation?.LowImpactWhyDidITakeThisApproach}
                                                                          onChange={this.props.handleChangePageData('TheSituation')}/>
                                                            </td>


                                                        </tr>


                                                        <tr>
                                                            <td width="40%" align="left" valign="center"
                                                                className="lightgreen subtiltereg "
                                                                style={{paddingBottom:'0px'}}>What were the highs:
                                                            </td>
                                                            <td width="30%" align="left" valign="top"
                                                                className="lightgreen "></td>
                                                            <td width="30%" align="left" valign="top"
                                                                className="lightgreen "></td>
                                                        </tr>


                                                        <tr>
                                                            <td width="30%" align="left" valign="center"
                                                                className="darkgreen ">
                                                                <ul className="greenbullet-list">
                                                                    <li><p>What worked well?</p></li>
                                                                </ul>
                                                            </td>
                                                            <td width="30%" align="left" valign="top"
                                                                className="darkgreen ">
                                                                <textarea className="textboximpact1"
                                                                          name="HighImpactWhatWorkedWell"
                                                                          id="HighImpactWhatWorkedWell"
                                                                          value={pageData?.WhatWereTheHighs?.HighImpactWhatWorkedWell}
                                                                          onChange={this.props.handleChangePageData('WhatWereTheHighs')}/>
                                                            </td>
                                                            <td width="30%" align="left" valign="top"
                                                                className="darkgreen ">
                                                                <textarea className="textboximpact1"
                                                                          name="LowImpactWhatWorkedWell"
                                                                          id="LowImpactWhatWorkedWell"
                                                                          value={pageData?.WhatWereTheHighs?.LowImpactWhatWorkedWell}
                                                                          onChange={this.props.handleChangePageData('WhatWereTheHighs')}/>
                                                            </td>


                                                        </tr>
                                                        <tr>
                                                            <td width="30%" align="left" valign="center"
                                                                className="darkgreen ">
                                                                <ul className="greenbullet-list">
                                                                    <li><p>What aspects of the situation made me
                                                                        feel good?</p></li>
                                                                </ul>
                                                            </td>
                                                            <td width="30%" align="left" valign="top"
                                                                className="darkgreen ">
                                                                <textarea className="textboximpact1"
                                                                          name="HighImpactWhatAspectsOfTheSituationMadeMeFeelGood"
                                                                          id="HighImpactWhatAspectsOfTheSituationMadeMeFeelGood"
                                                                          value={pageData?.WhatWereTheHighs?.HighImpactWhatAspectsOfTheSituationMadeMeFeelGood}
                                                                          onChange={this.props.handleChangePageData('WhatWereTheHighs')}/>
                                                            </td>
                                                            <td width="30%" align="left" valign="top"
                                                                className="darkgreen ">
                                                                <textarea className="textboximpact1"
                                                                          name="LowImpactWhatAspectsOfTheSituationMadeMeFeelGood"
                                                                          id="LowImpactWhatAspectsOfTheSituationMadeMeFeelGood"
                                                                          value={pageData?.WhatWereTheHighs?.LowImpactWhatAspectsOfTheSituationMadeMeFeelGood}
                                                                          onChange={this.props.handleChangePageData('WhatWereTheHighs')}/>
                                                            </td>


                                                        </tr>
                                                        <tr>
                                                            <td width="30%" align="left" valign="center"
                                                                className="darkgreen ">
                                                                <ul className="greenbullet-list">
                                                                    <li><p>Why?</p></li>
                                                                </ul>
                                                            </td>
                                                            <td width="30%" align="left" valign="top"
                                                                className="darkgreen ">
                                                                <textarea className="textboximpact1"
                                                                          name="HighImpactWhy"
                                                                          id="HighImpactWhy"
                                                                          value={pageData?.WhatWereTheHighs?.HighImpactWhy}
                                                                          onChange={this.props.handleChangePageData('WhatWereTheHighs')}/>
                                                            </td>
                                                            <td width="30%" align="left" valign="top"
                                                                className="darkgreen ">
                                                                <textarea className="textboximpact1"
                                                                          name="LowImpactWhy"
                                                                          id="LowImpactWhy"
                                                                          value={pageData?.WhatWereTheHighs?.LowImpactWhy}
                                                                          onChange={this.props.handleChangePageData('WhatWereTheHighs')}/>
                                                            </td>


                                                        </tr>
                                                        <tr>
                                                            <td width="30%" align="left" valign="center"
                                                                className="darkgreen ">
                                                                <ul className="greenbullet-list">
                                                                    <li><p>What positive feedback did I get?</p>
                                                                    </li>
                                                                </ul>
                                                            </td>
                                                            <td width="30%" align="left" valign="top"
                                                                className="darkgreen ">
                                                                <textarea className="textboximpact1"
                                                                          name="HighImpactWhatPositiveFeedbackDidIGet"
                                                                          id="HighImpactWhatPositiveFeedbackDidIGet"
                                                                          value={pageData?.WhatWereTheHighs?.HighImpactWhatPositiveFeedbackDidIGet}
                                                                          onChange={this.props.handleChangePageData('WhatWereTheHighs')}/>
                                                            </td>
                                                            <td width="30%" align="left" valign="top"
                                                                className="darkgreen ">
                                                                <textarea className="textboximpact1"
                                                                          name="LowImpactWhatPositiveFeedbackDidIGet"
                                                                          id="LowImpactWhatPositiveFeedbackDidIGet"
                                                                          value={pageData?.WhatWereTheHighs?.LowImpactWhatPositiveFeedbackDidIGet}
                                                                          onChange={this.props.handleChangePageData('WhatWereTheHighs')}/>
                                                            </td>


                                                        </tr>


                                                        </tbody>
                                                    </table>

                                                    <div className="left-btn">
                                                        <div
                                                            onClick={this.props.handleChangePage('Page5')}
                                                            className="button-next-previous-done">&lt;&lt; Previous
                                                        </div>
                                                    </div>
                                                    <div className="right-btn">
                                                        <div
                                                            onClick={this.props.savePageData('Page7')}
                                                            className="button-next-previous-done">Next &gt;&gt;</div>
                                                    </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }